module.exports = __webpack_public_path__ + "img/no-vip.7ff17630.svg";